export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[680px] md:min-h-[780px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20atmospheric%20abstract%20background%20with%20flowing%20warm%20amber%20and%20deep%20crimson%20geometric%20shapes%20radiating%20from%20a%20central%20luminous%20core%2C%20interconnected%20golden%20nodes%20representing%20community%20stories%20and%20positive%20energy%2C%20sophisticated%20editorial%20design%20with%20dramatic%20contrast%2C%20rich%20dark%20warm%20tones%20with%20bright%20golden%20highlights%2C%20layered%20depth%20with%20organic%20flowing%20patterns%20and%20subtle%20light%20particles%2C%20premium%20cinematic%20composition&width=1800&height=1000&seq=hero-bg-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/65"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/30 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-500/25 text-accent-200 text-xs md:text-sm font-medium mb-5 md:mb-6 whitespace-nowrap border border-accent-400/20">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              正能量黑料精选平台
            </span>

            <h1 className="text-[28px] md:text-[42px] lg:text-[52px] font-heading font-bold text-background-50 leading-[1.15] mb-4 tracking-tight">
              黑料718
              <span className="block md:inline text-primary-300"> · 发现爆料圈中的正能量</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-background-200 font-light mb-2">
              聚焦积极黑料，分享暖心故事
            </p>

            <p className="text-sm md:text-base text-background-300/85 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-7 md:mb-9">
              黑料718是一个专注于正能量黑料内容精选与传播的独立平台。我们每日从海量爆料信息中甄选积极向上、温暖人心的黑料正能量故事，涵盖社会暖心事件、明星正能量八卦、职场励志爆料等多个领域。每一条内容都经过严格核实，确保真实可靠，让您在获取信息的同时收获温暖与力量。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7 md:mb-9">
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">50+</span>
                <span className="text-xs text-background-300/70 mt-0.5">每日精选内容</span>
              </div>
              <div className="w-px h-10 bg-background-200/20 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">8</span>
                <span className="text-xs text-background-300/70 mt-0.5">大主题领域</span>
              </div>
              <div className="w-px h-10 bg-background-200/20 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400">多重核实</span>
                <span className="text-xs text-background-300/70 mt-0.5">内容真实可靠</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                className="whitespace-nowrap w-full sm:w-auto px-9 py-3.5 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 active:scale-[0.98] transition-all cursor-pointer text-center shadow-lg shadow-primary-500/25"
              >
                <i className="ri-fire-line mr-1.5"></i>浏览热门话题
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); scrollTo('#features'); }}
                className="whitespace-nowrap w-full sm:w-auto px-9 py-3.5 border border-background-200/35 text-background-100 rounded-md font-medium text-sm hover:bg-background-50/8 active:scale-[0.98] transition-all cursor-pointer text-center"
              >
                <i className="ri-star-line mr-1.5"></i>了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20collage%20showing%20abstract%20interconnected%20story%20nodes%20glowing%20with%20warm%20golden%20and%20amber%20light%2C%20layered%20magazine-style%20composition%20with%20geometric%20shapes%2C%20newspaper%20clippings%20and%20digital%20content%20fragments%20arranged%20in%20harmonious%20flow%2C%20rich%20dark%20background%20with%20bright%20warm%20highlights%2C%20sophisticated%20media%20editorial%20aesthetic%2C%20high-end%20publication%20design%2C%20premium%20visual%20storytelling&width=1200&height=900&seq=hero-visual-v2&orientation=landscape"
                alt="黑料718正能量内容精选主视觉 - 温暖故事汇聚"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/15 to-transparent rounded-xl"></div>
              <div className="absolute inset-0 ring-1 ring-inset ring-background-50/8 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}